import React, {useEffect, useState} from "react";
import {Box, Button, Input, InputAdornment} from "@mui/material";
import {ReactComponent as SearchIcon} from "../../img/search_icon.svg";
import {ReactComponent as ClearIcon} from "../../img/close_icon.svg";
import {makeStyles} from "@mui/styles";
import {useDispatch, useSelector} from "react-redux";
import {setPreloader, setSearchValueAction} from "../../Redux/content-reducer";

const useStyles = makeStyles(theme => ({
    inputSearchWrapper: {
        display: `flex`,
        height: `100%`,
        justifyContent: `flex-end`,
        alignItems: `center`
    },
    inputSearch: {
        width: `100%`,
        fontSize: '14px',
        height: `36px`,
        lineHeight: `1`,
        backgroundColor: '#ffffff',
        border: `1px solid #888888`,
        borderRadius: '5px',
    }
}));

export const ScreenSearch = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const selectedOptionValue = localStorage.getItem("selectedOptionValue");

    const {contentData, dropdownsReducer} = useSelector(state => state);
    const [searchValue, changeSearchValue] = useState(contentData.searchValue);

    useEffect(() => {
        changeSearchValue(contentData.searchValue);
    }, [contentData.searchValue]);

    const onChangeValue = (event) => {
        changeSearchValue(event.target.value);
    }

    const onSearchCurrentValue = (event) => {
        event.preventDefault();
        console.log(contentData);
        console.log(dropdownsReducer);
        console.log(searchValue);
        console.log(props);
        dispatch(setSearchValueAction(searchValue));
        dispatch(setPreloader(true));
        if(contentData.isActivePromosScreen){
            props.getDataTable(selectedOptionValue, dropdownsReducer.format, dropdownsReducer.supplierValues.promos, dropdownsReducer.productCategoryValues.promos, searchValue.trim().toLowerCase(), true);
        } else {
            props.getDataTableForRegularPrices(selectedOptionValue, dropdownsReducer.format, dropdownsReducer.supplierValues.prices, dropdownsReducer.productCategoryValues.prices, searchValue.trim().toLowerCase(), true);
        }
    }

    const onClearCurrentValue = (event) => {
        changeSearchValue(``);
        dispatch(setSearchValueAction(``));
        dispatch(setPreloader(true));
        if(contentData.isActivePromosScreen){
            props.getDataTable(selectedOptionValue, dropdownsReducer.format, dropdownsReducer.supplierValues.promos, dropdownsReducer.productCategoryValues.promos, ``, true)
        } else {
            props.getDataTableForRegularPrices(selectedOptionValue, dropdownsReducer.format, dropdownsReducer.supplierValues.prices, dropdownsReducer.productCategoryValues.prices, ``, true);
        }
    }

    return (
        <Box className={classes.inputSearchWrapper}>
            <form onSubmit={onSearchCurrentValue} style={{width: `60%`}}>
                <Input
                    startAdornment={
                        <InputAdornment position={'start'} sx={{px: '10px', mx: '0'}}>
                            <Button
                                type={"submit"}
                                onClick={onSearchCurrentValue}
                                sx={{p: `5px`}}
                            >
                                <SearchIcon />
                            </Button>
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position={'end'} sx={{px: '10px', m: '0'}}>
                            <Button
                                onClick={onClearCurrentValue}
                                sx={{p: `5px`}}
                                // color={`primary.main`}
                            >
                                <ClearIcon />
                            </Button>
                        </InputAdornment>
                    }
                    // onFocus={onFocus}
                    // onBlur={onUnFocusInput}
                    onChange={onChangeValue}
                    placeholder={``}
                    // placeholder={isHebrewStyle ? "חיפוש" : "Search"}
                    type={`text`}
                    value={searchValue}
                    disableUnderline
                    className={classes.inputSearch}
                >

                </Input>
            </form>
        </Box>
    )
}